module.exports = __webpack_public_path__ + "static/media/kingstoncity-logo.59e059d4.png";